// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b47a3910","732":"d9a06cd0","977":"d59fb2d3"}[chunkId] + ".chunk.js";
};